import { useSelector } from "react-redux";

import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";

export const useGlobalSelectedAdvertiser = () => {
  const selectedAdvertiserId = useSelector((state: ReduxApplicationState) => state.agency.selectedAdvertiserId);
  const selectedAdvertiser = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedAdvertiser);
  const advertisers = useSelector((state: ReduxApplicationState) => state.agency.advertisers);

  const brandgenAdvertiserId = selectedAdvertiserId ?? selectedAdvertiser?.brandgenAdvertiserId ?? null;

  return {
    advertisers,
    selectedAdvertiserId,
    selectedAdvertiser,
    brandgenAdvertiserId,
    adLibAdvertiserId: selectedAdvertiser?.adLibAdvertiserId ?? null,
  };
};
